// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".giftcard-component{align-content:left;font-size:16px;margin:0;padding:0}.giftcard-component__title{font-size:30px;font-weight:400}.giftcard-component__text{font-size:16px;font-weight:400}.giftcard-component .giftcard-btn{border:2px solid;text-transform:none}@media(min-width:1904px){.giftcard-component{max-width:1185px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
